const validateStr = {
  usernameRequired: "ユーザー名を入力してください。",
  phoneRequired: "電話番号を入力してください。",
  menuRequired: "メニューを選択してください。",
  staffRequired: "スタッフを選択してください。",
  tableRequired: "テーブルを選択してください。",
};

export default validateStr;
